import { BASE_URL } from "../serviceUrls";

function header(token) {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

export const postData = (api, body, token) =>
  fetch(`${BASE_URL}/${api}`, {
    method: "POST",
    headers: {
      ...header(token),
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });

export const putData = (api, body, token) =>
  fetch(`${BASE_URL}/${api}`, {
    method: "PUT",
    headers: {
      ...header(token),
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });

export const patchData = (api, body, token) =>
  fetch(`${BASE_URL}/${api}`, {
    method: "PATCH",
    headers: {
      ...header(token),
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });

export const getData = (api, token) =>
  fetch(`${BASE_URL}/${api}`, {
    method: "GET",
    headers: {
      ...header(token),
    },
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });

export const deleteData = (api, token) =>
  fetch(`${BASE_URL}/${api}`, {
    method: "DELETE",
    headers: {
      ...header(token),
    },
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        // Create an error object that includes the response data
        const error = new Error(
          data.error || data.message || `HTTP ${res.status}: ${res.statusText}`
        );
        error.response = { data, status: res.status };
        throw error;
      }

      return data;
    })
    .catch((error) => {
      // If it's already our custom error, re-throw it
      if (error.response) {
        throw error;
      }
      // Network error - return the original format for compatibility
      return { hasError: true, message: "Network error" };
    });
